/**
 * Credit-based pricing for pro search plans.
 */

import { CLUMSE_SEARCH_FEE_USD } from "../utils/tierClassification";

export { CLUMSE_SEARCH_FEE_USD };

/** Public marketing headline for the one-time search fee. */
export const CLUMSE_SEARCH_FEE_MARKETING_HEADLINE =
  "Flat $49 Diagnostic & Project Blueprint Fee";

/** Canonical FAQ answer for search-fee questions. */
export const CLUMSE_SEARCH_FEE_FAQ_ANSWER =
  "Clumse charges a flat $49 search fee to generate your AI project blueprint and match you with 3 vetted local pros. There are zero hidden costs, subscription models, or contractor lead fees.";

const flatFee = CLUMSE_SEARCH_FEE_USD;

// Strategic pivot: Only Individual (pay-as-you-go) plan now available
export const ADVISOR_PLANS = [
  {
    id: "individual",
    title: "Individual",
    subtitle:
      "Simple, transparent, pay-as-you-go. No monthly fees. No subscription required.",
    monthlyFee: 0,
    creditsPerMonth: 0,
    rolloverCap: 0,
    priceLines: [
      { text: "$0", suffixGreen: "/month" },
      { text: `$${flatFee}`, suffixGreen: " flat search fee" },
      { text: "Any project size", suffixGreen: "" },
    ],
    searchFees: { minor: flatFee, major: flatFee, capex: flatFee },
    creditCosts: { small_repair: 1, major_system: 3, big_project: 10 },
    detail: `Perfect for any residential project. Start with a free AI diagnosis, then pay a flat $${flatFee} when you're ready for your project blueprint and 3 vetted local bids—from appliance fixes to driveway and porch conversions.`,
    cta: "Start Free",
    isDefault: true,
  },
];

export const PROCUREMENT_ENTERPRISE = null; // Replaced with Institutional plan

/** Feature bullets for marketing intake - Individual plan only */
export const ADVISOR_TIER_FEATURES = Object.freeze({
  individual: Object.freeze({
    name: "Individual",
    tagline:
      "Simple, transparent, pay-as-you-go. No monthly fees. No subscription required.",
    features: Object.freeze([
      "Free AI diagnosis and repair cost estimates",
      "Expert advisor guidance",
      "3 bids guaranteed",
      "Direct contractor communication",
      `Flat $${flatFee} search fee for every project size`,
      "No subscription required",
    ]),
  }),
});

function advisorTabMeta(planId) {
  if (planId === "individual") return `$0/month • $${flatFee} flat search fee`;
  return "";
}

/**
 * Options for IntakeModal plan tabs (Individual / Portfolio / Institutional).
 */
export function getAdvisorIntakePlanOptions() {
  return ADVISOR_PLANS.map((p) => ({
    value: p.id,
    label: p.title,
    marketingLabel: p.title,
    tabPrice: advisorTabMeta(p.id),
    price: p.monthlyFee,
    searchFees: p.searchFees,
    isDefault: p.isDefault,
    maxUnits: p.maxUnits,
  }));
}

export function getAdvisorSummaryPriceParts(planKey) {
  const k = String(planKey || "").toLowerCase();
  const plan = ADVISOR_PLANS.find((p) => p.id === k) || ADVISOR_PLANS[0];

  if (plan.monthlyFee === 0) {
    return {
      dollars: "Free",
      period: ` • $${flatFee} when you start search`,
    };
  }

  return {
    dollars: `$${plan.monthlyFee}`,
    period: "/month",
  };
}

// Legacy compatibility exports
export const PROCUREMENT_GRID_PLANS = ADVISOR_PLANS;
export const PROCUREMENT_TIER_DETAIL = ADVISOR_TIER_FEATURES;
export const getProcurementIntakePlanOptions = getAdvisorIntakePlanOptions;
export const getProcurementSummaryPriceParts = getAdvisorSummaryPriceParts;
